export default "__VITE_ASSET__Cp2ZNQ7X__"